import styled from "styled-components";

export const HeaderMobileWrapper = styled.div`
  display: none;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 4rem;
  flex-shrink: 0;
  padding: 0 ${(props) => props.theme.spacing.medium};
  color: ${(props) => props.theme.colors.font.secondary};
  position: sticky;
  top: 0;
  z-index: 100;
  gap: ${(props) => props.theme.spacing.medium};
  background-color: ${(props) => props.theme.background.primary};
  > svg {
    width: 2rem;
    height: 2rem;
  }

  > img {
    width: auto;
    height: 2.5rem;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    display: flex;
  }
`;

export const HamburgerMenuWrapper = styled.div<{ $isOpen?: boolean }>`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 9999;
  width: 80vw;
  background-color: ${(props) => props.theme.background.primary};
  border-top-left-radius: ${(props) => props.theme.spacing.large};
  border-bottom-left-radius: ${(props) => props.theme.spacing.large};
  padding: ${(props) => props.theme.spacing.large};
  transform: ${(props) => (props.$isOpen ? "translateX(0)" : "translateX(100%)")};
  transition: transform 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.2);
`;

export const HamburgerMenuBody = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const HamburgerMenuClose = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 1rem;

  > span {
    > svg {
      height: 2rem;
      width: auto;
      color: #fff;
      cursor: pointer;
    }
  }
`;

export const HamburgerMenuContent = styled.div`
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  flex-direction: column;
  gap: 0.25rem;
  margin-top: 1rem;
`;

export const ActionButton = styled.button`
  width: 60%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.6rem ${(props) => props.theme.spacing.medium};
  color: ${(props) => props.theme.colors.font.secondary};
  font-size: ${(props) => props.theme.fontSizes.large};
  font-weight: 300;
  outline: 0;
  border: 0;
  border-radius: 1.5rem;
  cursor: pointer;
  transition: background 0.1s ease-in-out, border 0.1s ease-in-out;
  background: ${(props) => props.theme.colors.accent2};
  margin-top: ${(props) => props.theme.spacing.medium};
  margin-bottom: ${(props) => props.theme.spacing.large};
  border: 1px solid ${(props) => props.theme.colors.accent2};

  > svg {
    margin-left: ${(props) => props.theme.spacing.small};
    color: ${(props) => props.theme.colors.font.secondary};
  }
`;

export const MobileNavItem = styled.div<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  background-color: ${(props) => props.$isActive ? 'rgba(209, 250, 229, 0.1)' : 'transparent'};
  color: ${(props) => props.$isActive ? '#D1FAE5' : '#ffffff'};
  font-size: 0.875rem;
  font-weight: ${(props) => props.$isActive ? 600 : 400};
  width: 100%;

  &:hover {
    background-color: rgba(255, 255, 255, 0.05);
  }

  > svg {
    flex-shrink: 0;
  }
`;

export const MobileUserSection = styled.div`
  margin-top: auto;
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  width: 100%;
  position: relative;
`;

export const MobileUserAvatar = styled.div<{ $bgColor: string; $textColor: string }>`
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background-color: ${(props) => props.$bgColor};
  color: ${(props) => props.$textColor};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.875rem;
  flex-shrink: 0;
`;

export const MobileUserInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

export const MobileUserMenu = styled.div`
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  margin-bottom: 0.5rem;
  background-color: #1f2937;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  z-index: 10;
`;

export const MobileUserMenuItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  cursor: pointer;
  color: #ffffff;
  font-size: 0.875rem;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  > svg {
    flex-shrink: 0;
  }
`;

export const MobileTrialBanner = styled.div<{ $type: 'info' | 'warning' }>`
  margin: 0.5rem 0;
  padding: 0.75rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  background-color: ${(props) => {
    if (props.$type === 'warning') {
      return '#fef3c7';
    }
    return '#dbeafe';
  }};
  border: 1px solid ${(props) => {
    if (props.$type === 'warning') {
      return '#fbbf24';
    }
    return '#60a5fa';
  }};
  color: ${(props) => {
    if (props.$type === 'warning') {
      return '#92400e';
    }
    return '#1e40af';
  }};
  text-align: center;
  font-weight: 500;
  font-size: 0.75rem;
  line-height: 1.4;

  &:hover {
    background-color: ${(props) => {
      if (props.$type === 'warning') {
        return '#fde68a';
      }
      return '#bfdbfe';
    }};
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;
